import React from 'react';
import './TicketList.css';

import TicketCard from '../TicketCard/TicketCard';
import PostalEntry from '../PostalEntry/PostalEntry';
import SubscriptionEntry from '../SubscriptionEntry/SubscriptionEntry';
import ReactHtmlParse from 'html-react-parser';
import useTickets from '../../hooks/useTickets';
import {TitleText, SubtitleText} from "raffle-house-uikit";
import NewPrizeCard from '../common/NewTicketCard';

const TicketList = (props) => {
  const {
    prizeId,
    raffles,
    isExpired,
    currentRaffle,
    title,
    subtitle,
    theme = 'light',
    reference,
    bonusDraw,
  } = props;
  const {
    type,
    loading,
    activeTicket,
    addToBasket,
    result,
    ticketsBundles,
  } = useTickets({prizeId, isDouble: raffles.length > 1});

  return (
    <div className='ticket-container' ref={reference}>
      {title || subtitle ? (
        <div className="ticket-text-container">
          {Boolean(title) && (
            <TitleText
              isCentered
              as="h2"
              variant={"primary"}
              color={`${theme === "light" ? "color-1" : "color-5"}`}
            >
              {title ? ReactHtmlParse(title) : null}
            </TitleText>
          )}
          {Boolean(subtitle) && (
            <SubtitleText
              isCentered
              color={`${theme === "light" ? "color-1" : "color-5"}`}
            >
              {subtitle ? ReactHtmlParse(subtitle) : null}
            </SubtitleText>
          )}
        </div>
      ) : null}
      <div className='ticket-list'>
        <>
          {prizeId &&
            ticketsBundles?.map((bundle, index) => {
              let label = '';
              if (bundle.tickets === 15) {
                label = 'MOST POPULAR';
              } else if (bundle.tickets === 30) {
                label = 'LOWEST TICKET PRICE';
              }
              return (
                <NewPrizeCard
                  type={type}
                  key={index}
                  activeTicket={activeTicket}
                  ticketBundle={bundle}
                  loading={loading}
                  onClick={addToBasket}
                  raffles={raffles}
                  isExpired={isExpired}
                  currentRaffle={currentRaffle}
                  theme={theme}
                  label={label}
                  result={result}
                  bonusDraw={bonusDraw}
                />
              );
            })}
          <PostalEntry loading={loading} theme={raffles.length > 1 ? 'light' : theme} />
        </>
      </div>
    </div>
  );
};

export default TicketList;
